import {
  LIST_STORES_SUCCESS,
  LIST_STORES_ERROR,
  LIST_SECTION_BLOCK_SUCCESS,
  LIST_SECTION_BLOCK_ERROR,
  SAVE_SECTION_BLOCK_SUCCESS,
  SAVE_SECTION_BLOCK_ERROR,
  DELETE_SECTION_BLOCK_SUCCESS,
  DELETE_SECTION_BLOCK_ERROR,
  CLEAR_SUCCESS_MESSAGE,
} from 'actionTypes'

const DEFAULT_STATE = {
  list: [],
  sectionList: {
    2: [],
    3: [],
    4: [],
    5: [],
  },
  storeList: [],
  success: '',
  error: null,
}

export default (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case LIST_STORES_SUCCESS:
      return { ...state, storeList: action.payload }
    case LIST_SECTION_BLOCK_SUCCESS:
      return { ...state, list: action.payload }
    case SAVE_SECTION_BLOCK_SUCCESS:
      return {
        ...state,
        success: 'mobile.punctual.adjust.sectionBlock.save.success',
        error: null,
      }
    case DELETE_SECTION_BLOCK_SUCCESS:
      return {
        ...state,
        success: 'mobile.punctual.adjust.sectionBlock.delete.success',
        error: null,
      }
    case LIST_STORES_ERROR:
    case LIST_SECTION_BLOCK_ERROR:
    case SAVE_SECTION_BLOCK_ERROR:
    case DELETE_SECTION_BLOCK_ERROR:
      return { ...state, success: '', error: action.payload }
    case CLEAR_SUCCESS_MESSAGE:
      return { ...state, success: '' }
    default:
      return { ...state }
  }
}
